
export interface IStellaSoraSkill {
	id: number;
	name: string;
	briefDesc: string;
	desc: string;
	damageType: string[];
	effectType: string[];
	addAttrType: string[];
	params: (string|number)[];
	icon: string;
	cooldown?: string;
	energy?: number;
}
export interface IStellaSoraPotential {
	id: number;
	addAttrType: string[];
	briefDesc: string;
	corner: string;
	damageType: string[];
	desc: string;
	effectData: string[];
	effectType: string[];
	icon: string;
	name: string;
	params: string[];
	rarity: string;
}
export interface IStellaSoraCharacter {
	id: number;
	name: string;
	star: number;
	element: string;
	class: string;
	attackType: string;
	tag: string[];
	loveGift: string[];
	hateGift: string[];
	date: any[];
	normalAtk: IStellaSoraSkill;
	skill: IStellaSoraSkill;
	supportSkill: IStellaSoraSkill;
	ultimate: IStellaSoraSkill;
	potential: {
		common: IStellaSoraPotential[];
		mainCore: IStellaSoraPotential[];
		mainNormal: IStellaSoraPotential[];
		supportCore: IStellaSoraPotential[];
		supportNormal: IStellaSoraPotential[];
	};
	talent: any[];
	upgrade: any[];
	skillUpgrade: any[];
	stat: {hp: number; atk: number;}[];
}
export class StellaSoraPotential implements IStellaSoraPotential {
	id: number;
	addAttrType: string[];
	briefDesc: string;
	corner: string;
	damageType: string[];
	desc: string;
	effectData: string[];
	effectType: string[];
	icon: string;
	name: string;
	params: string[];
	rarity: string;
	rarityVal: number;
	maxLevel: number = 1;
	constructor(raw: IStellaSoraPotential) {
		this.id = raw.id;
		this.addAttrType = raw.addAttrType;
		this.briefDesc = raw.briefDesc;
		this.corner = raw.corner;
		this.damageType = raw.damageType;
		this.desc = raw.desc;
		this.effectData = raw.effectData;
		this.effectType = raw.effectType;
		this.icon = raw.icon;
		this.name = raw.name;
		this.params = raw.params;
		this.rarity = raw.rarity;
		switch(this.rarity) {
			case "core": this.rarityVal = 3; break;
			case "rare": this.rarityVal = 2; break;
			case "common": this.rarityVal = 1; break;
			default: this.rarityVal = 0; break;
		}
		for (let p of this.params) {
			this.maxLevel = Math.max(p.toString().split("/").length, this.maxLevel);
		}
	}
	getBackground() {
		return `/img/StellaSora/potential_bg_${this.rarity}.png`;
		// switch (this.rarity) {
		// 	case "core": return `img/StellaSora/potential_bg_${this.rarity}.png`;
		// 	case "rare": return `img/StellaSora/potential_bg_${this.rarity}.png`;
		// 	case "common": return `img/StellaSora/potential_bg_${this.rarity}.png`;
		// 	// case "core": return "https://noyanoya.vercel.app/ss-vestige/vestige_0.png";
		// 	// case "rare": return "https://noyanoya.vercel.app/ss-vestige/vestige_1.png";
		// 	// case "common": return "https://noyanoya.vercel.app/ss-vestige/vestige_2.png";
		// }
		// return `https://raw.githubusercontent.com/AutumnVN/stelladb/refs/heads/main/public/${this.rarity}.png`
		// return `https://raw.githubusercontent.com/AutumnVN/stelladb/refs/heads/main/public/${this.rarity}.png`
	}
	getIcon() {
		return `https://raw.githubusercontent.com/AutumnVN/ssassets/refs/heads/main/export/assets/assetbundles/icon/potential/${this.icon}_A.webp`
	}
	getCorner() {
		return `https://raw.githubusercontent.com/AutumnVN/ssassets/refs/heads/main/export/assets/assetbundles/icon/potential/Potential_${this.corner}_A.webp`
	}
	compare(other:StellaSoraPotential) {
		return this.id - other.id;
	}
	getDescription(level?:number) {
		if (typeof(level) === "undefined" || level < 1) {
			level = 1;
		}
		let desc = this.desc;
		for (let i=0; i<this.params.length; i++) {
			const params = `${this.params[i]}`.split("/");
			let paramVal = params[Math.min(level-1, params.length-1)];
			desc = desc.replaceAll(`&Param${i+1}&`, paramVal);
		}
		return desc.replaceAll(/(<.+?>)/gi, "**")
		.replaceAll(/(#.*?#)/gi, "_")
		.replaceAll("\u000b", "\n\n");
	}
}
export class StellaSoraSkill implements IStellaSoraSkill {
	id: number;
	name: string;
	briefDesc: string;
	desc: string;
	damageType: string[];
	effectType: string[];
	addAttrType: string[];
	params: (string|number)[];
	numberParams: number[][] = [];
	icon: string;
	cooldown?: string;
	energy?: number;
	constructor(raw: IStellaSoraSkill) {
		this.id = raw.id; 
		this.name = raw.name;
		this.briefDesc = raw.briefDesc;
		this.desc = raw.desc;
		this.damageType = raw.damageType;
		this.effectType = raw.effectType;
		this.addAttrType = raw.addAttrType;
		this.params = raw.params;
		for(let param of raw.params) {
			if (typeof(param) === "string") {
				try {
					const numberParam = param.split("/").map(p=>{
						if (p.trim().endsWith("%")) {
							return parseFloat(p.trim().slice(0, -1))/100;
						} else {
							return parseFloat(p.trim());
						}
					})
					this.numberParams.push(numberParam);
				} catch {
					this.numberParams.push([]);
				}
			}
		}
		this.icon = raw.icon;
		this.cooldown = raw.cooldown;
		this.energy = raw.energy;
	}
}
export interface IStellaSoraItem {
	id: number;
	name: string;
	desc: string;
	literary: string;
	type: string;
	rarity: string;
}
export class StellaSoraItem implements IStellaSoraItem {
	id: number;
	name: string;
	desc: string;
	literary: string;
	type: string;
	rarity: string;
	constructor(raw: IStellaSoraItem) {
		this.id = raw.id;
		this.name = raw.name;
		this.desc = raw.desc;
		this.literary = raw.literary;
		this.type = raw.type;
		this.rarity = raw.rarity;
	}

	toString() {
		return this.id;
	}

	getIcon() {
		return `https://raw.githubusercontent.com/AutumnVN/ssassets/refs/heads/main/export/assets/assetbundles/icon/item/item_${this.id}.webp`
	}

	getRarityValue() {
		switch(this.rarity) {
			case "M": return 1;
			case "R": return 2;
			case "SR": return 3;
			default: return 0;
		}
	}

	compare(other: StellaSoraItem) {
		return this.getRarityValue() - other.getRarityValue();
	}
}

export class StellaSoraCharacter implements IStellaSoraCharacter {
	id: number;
	name: string;
	star: number;
	element: string;
	class: string;
	attackType: string;
	tag: string[];
	loveGift: string[];
	hateGift: string[];
	date: any[];
	normalAtk: StellaSoraSkill;
	skill: StellaSoraSkill;
	supportSkill: StellaSoraSkill;
	ultimate: StellaSoraSkill;
	potential: {
		common: StellaSoraPotential[];
		mainCore: StellaSoraPotential[];
		mainNormal: StellaSoraPotential[];
		supportCore: StellaSoraPotential[];
		supportNormal: StellaSoraPotential[];
	};
	talent: any[];
	upgrade: any[];
	upgradeMats: StellaSoraItem[];
	stat: {hp: number; atk: number;}[];
	skillUpgrade: any[];
	skillUpgradeMats: StellaSoraItem[];
	weeklyUpgradeMats: StellaSoraItem[];
	lovedGiftItems: StellaSoraItem[];
	constructor(raw: IStellaSoraCharacter) {
		this.id = raw.id;
		this.name = raw.name;
		this.star = raw.star;
		this.element = raw.element;
		this.class = raw.class;
		this.attackType = raw.attackType;
		this.tag = raw.tag;
		this.loveGift = raw.loveGift;
		this.hateGift = raw.hateGift;
		this.date = raw.date;
		this.normalAtk = new StellaSoraSkill(raw.normalAtk);
		this.skill = new StellaSoraSkill(raw.skill);
		this.supportSkill = new StellaSoraSkill(raw.supportSkill);
		this.ultimate = new StellaSoraSkill(raw.ultimate);
		this.potential = {
			common: raw.potential.common.map(p=>new StellaSoraPotential(p)),
			mainCore: raw.potential.mainCore.map(p=>new StellaSoraPotential(p)),
			mainNormal: raw.potential.mainNormal.map(p=>new StellaSoraPotential(p)),
			supportCore: raw.potential.supportCore.map(p=>new StellaSoraPotential(p)),
			supportNormal: raw.potential.supportNormal.map(p=>new StellaSoraPotential(p)),
		};
		for (const t of Object.keys(this.potential)) {
			this.potential[t].sort((a,b)=>a.compare(b));
		}
		this.talent = raw.talent;
		this.upgrade = raw.upgrade;
		this.skillUpgrade = raw.skillUpgrade;
		this.stat = raw.stat;
	}

	extractItems(itemDb: StellaSoraItem[]) {
		const upgradeMats = new Set<StellaSoraItem>();
		for (let upg of this.upgrade) {
			for (let mat of Object.keys(upg)) {
				if (mat === "Dorra") continue;
				upgradeMats.add(itemDb.find(i=>i.name.toString()===mat));
			}
		}
		const skillUpgradeMats = new Set<StellaSoraItem>();
		for (let upg of this.skillUpgrade) {
			for (let mat of Object.keys(upg)) {
				if (mat === "Dorra") continue;
				if (mat === "Chess Piece of Skill") continue;
				if (upg[mat] < 10) continue;
				skillUpgradeMats.add(itemDb.find(i=>i.name.toString()===mat));
			}
		}

		const lovedGiftItems = new Set<StellaSoraItem>();
		for (let item of this.loveGift) {
			lovedGiftItems.add(itemDb.find(i=>i.name.toString()===item));
		}
		this.lovedGiftItems = Array.from(lovedGiftItems);
		this.upgradeMats = Array.from(upgradeMats);
		this.skillUpgradeMats = Array.from(skillUpgradeMats);
		const weeklyUpgradeMats = new Set<StellaSoraItem>();
		for (let upg of this.skillUpgrade) {
			for (let mat of Object.keys(upg)) {
				if (mat === "Dorra") continue;
				if (mat === "Chess Piece of Skill") continue;
				const item = itemDb.find(i=>i.name.toString()===mat);
				if (this.skillUpgradeMats.includes(item)) continue;
				weeklyUpgradeMats.add(item);
			}
		}
		this.weeklyUpgradeMats = Array.from(weeklyUpgradeMats);
		this.upgradeMats.sort((a,b)=>a.compare(b));
		this.skillUpgradeMats.sort((a,b)=>a.compare(b));
		this.weeklyUpgradeMats.sort((a,b)=>a.compare(b));
		return this;
	}

	getPotentials(isMain:boolean) {
		if (isMain) {
			const rares=this.potential.mainNormal.filter(p=>p.rarity==="rare");
			const comms=this.potential.mainNormal.filter(p=>p.rarity==="common");
			return [
				[
					this.potential.mainCore[0],
					this.potential.mainCore[1],
					rares[0],
					comms[0],
					comms[1],
				],
				[
					this.potential.mainCore[2],
					this.potential.mainCore[3],
					rares[1],
					comms[2],
					comms[3],
				],
				[
					rares[2],
					comms[4],
					comms[5],
					...this.potential.common
				],
			]
		} else {
			const rares=this.potential.supportNormal.filter(p=>p.rarity==="rare");
			const comms=this.potential.supportNormal.filter(p=>p.rarity==="common");
			return [
				[
					this.potential.supportCore[0],
					this.potential.supportCore[1],
					rares[0],
					comms[0],
					comms[1],
				],
				[
					this.potential.supportCore[2],
					this.potential.supportCore[3],
					rares[1],
					comms[2],
					comms[3],
				],
				[
					rares[2],
					comms[4],
					comms[5],
					...this.potential.common
				],
			]
		}
	}

	getAtomicPotentials(isMain:boolean) {
		if (isMain) {
			const rares=this.potential.mainNormal.filter(p=>p.rarity==="rare");
			const comms=this.potential.mainNormal.filter(p=>p.rarity==="common");
			return [
					this.potential.mainCore[0],
					this.potential.mainCore[1],
					rares[0],
					comms[0],
					comms[1],
					this.potential.mainCore[2],
					this.potential.mainCore[3],
					rares[1],
					comms[2],
					comms[3],
					rares[2],
					comms[4],
					comms[5],
					...this.potential.common
			]
		} else {
			const rares=this.potential.supportNormal.filter(p=>p.rarity==="rare");
			const comms=this.potential.supportNormal.filter(p=>p.rarity==="common");
			return [
					this.potential.supportCore[0],
					this.potential.supportCore[1],
					rares[0],
					comms[0],
					comms[1],
					this.potential.supportCore[2],
					this.potential.supportCore[3],
					rares[1],
					comms[2],
					comms[3],
					rares[2],
					comms[4],
					comms[5],
					...this.potential.common
			]
		}
	}
	getIcon() {
		return `https://raw.githubusercontent.com/AutumnVN/ssassets/refs/heads/main/export/assets/assetbundles/icon/head/head_${this.id}01_L.webp`;
	}
}
